/**
 * Detects focus events caused by Quill hydrating HTML into the editor.
 * JobForm uses this so section tabs stay on Basics until the user focuses a field.
 */
export const isProgrammaticRichTextFocus = (target: EventTarget | null): boolean => {
  if (!(target instanceof Element)) {
    return false;
  }

  return Boolean(target.closest('[data-rte-syncing="true"]'));
};
